// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file app.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file app.proto.
 */
export const file_app: GenFile = /*@__PURE__*/
  fileDesc("CglhcHAucHJvdG8SC2dycGMuYXBpLnYxIlwKA0FwcBIKCgJpZBgBIAEoAxIMCgRuYW1lGAIgASgJEhMKC2lzSW5zdGFsbGVkGAMgASgIEhYKDnNob3dBc01lbnVJdGVtGAQgASgIEg4KBnBhcmFtcxgFIAEoCUIGWgQuO3BiYgZwcm90bzM");

/**
 * App
 *
 * @generated from message grpc.api.v1.App
 */
export type App = Message<"grpc.api.v1.App"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bool isInstalled = 3;
   */
  isInstalled: boolean;

  /**
   * @generated from field: bool showAsMenuItem = 4;
   */
  showAsMenuItem: boolean;

  /**
   * @generated from field: string params = 5;
   */
  params: string;
};

/**
 * Describes the message grpc.api.v1.App.
 * Use `create(AppSchema)` to create a new message.
 */
export const AppSchema: GenMessage<App> = /*@__PURE__*/
  messageDesc(file_app, 0);

